"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrowserEventBus = void 0;
class BrowserEventBus {
    constructor(eventNameSpace) {
        this.eventNameSpace = eventNameSpace;
    }
    publish(eventName, payload) {
        const event = new CustomEvent(this.getFullEventName(eventName), { detail: payload });
        document.dispatchEvent(event);
    }
    subscribe(eventName, handler) {
        document.addEventListener(this.getFullEventName(eventName), handler);
        return () => {
            document.removeEventListener(this.getFullEventName(eventName), handler);
        };
    }
    getFullEventName(eventName) {
        return `${this.eventNameSpace}/${eventName}`;
    }
}
exports.BrowserEventBus = BrowserEventBus;
//# sourceMappingURL=event-bus.js.map